import React, { useEffect, useMemo } from 'react';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import ConditionsTopPanel from './ConditionsTopPanel';
import renderStepData from './ConditionsUtils';

import './Conditions.scss';

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable  react/default-props-match-prop-types */
function Conditions({
  routeType,
  placement,
  setPlacement,
  setIsShown,
  activeStep,
  setActiveStep,
  steps,
  fetchStepData,
  onUnmount = () => null,
  resized,
  onActiveStepChange,
  onFullTextLinkClick = () => null,
  onIssueCitedCounterClick = () => null,
  onExperimentalProcedureOpen = () => null,
  onAbstractOpen = () => null,
  onAuthorClick = () => null,
  saveStepSelectionsHandler = () => null,
  loadLastExamples,
}) {
  const activeStepData = useMemo(() => find(steps, { step: activeStep }), [steps, activeStep]);
  const activeStepType = (activeStepData && activeStepData.type) || routeType;

  useEffect(() => {
    // If conditions opened, but no active step selected - select 1st as active
    if (!activeStep && !isEmpty(steps)) {
      setActiveStep(steps[0].step);
    }
  }, [steps]);

  useEffect(() => {
    // If step is opened but no data and was not yet requested - fetch data for step
    if (activeStepData && !activeStepData.data && !activeStepData.requested) {
      fetchStepData(activeStepType, activeStepData);
    }
  }, [activeStep]);

  useEffect(
    () => () => {
      onUnmount();
    },
    []
  );

  return (
    <>
      {steps && (
        <ConditionsTopPanel
          placement={placement}
          setPlacement={setPlacement}
          setIsShown={setIsShown}
          steps={steps}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          resized={resized}
          onActiveStepChange={onActiveStepChange}
          routeType={routeType}
        />
      )}
      {renderStepData({
        placement,
        onFullTextLinkClick,
        onIssueCitedCounterClick,
        onExperimentalProcedureOpen,
        onAbstractOpen,
        onAuthorClick,
        saveStepSelectionsHandler,
        loadLastExamples,
        ...activeStepData,
        type: activeStepType,
      })}
    </>
  );
}

Conditions.propTypes = {
  saveStepSelectionsHandler: PropTypes.func,
  loadLastExamples: PropTypes.func,
};

export default Conditions;
